import { Autocomplete, Box, Button, FormControl, Stack, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@mui/material";
import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dayjs } from "dayjs";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { RootState } from "../../../global/config/store";
import { setSelectedClientGroup } from "../../../global/config/Reducer/clientSlice.ts";
import { ApiGetClientEntityByClientGroupId } from "../../../apiService/Core/Apicall.tsx";
import { ApigetCategoryCmparisionExcel, ApigetCategoryCmparisionReport } from "../../../apiService/Core/CustomApiManageReports.tsx";

interface ClientType {
    clientId: number;
    clientName: string;
}
interface ClientEntity {
    clientEntityId: number;
    entityName: string;
}

const CategoryReport: React.FC = () => {

    const dispatch = useDispatch();
    const Clientlist = useSelector((state: RootState) => state.client.clientList);
    const selectedClientName = useSelector((state: RootState) => state.client.selectedClient)
    const [selectedGroupDbName, setSelectedGroupDbName] = useState<any>(selectedClientName);
    const [clients, setClients] = useState<any>([]);
    const [clientEntities, setClientEntities] = useState<ClientEntity[]>([]);
    const [selectedEntityId, setSelectedEntityId] = useState<number | null>(null);
    const [selectedClient, setSelectedClient] = useState<ClientType | null>(null);
    const [reportData, setReportData] = useState<any>([]);
    const MAX_MONTHS_DISPLAYED = 12;
    const [startMonth, setStartMonth] = useState<Dayjs | null>(null);
    const [endMonth, setEndMonth] = useState<Dayjs | null>(null);
    const [filteredMonths, setFilteredMonths] = useState<string[]>([]);
    const pdfRef = useRef<HTMLDivElement>(null);
    const [categoryComparisonData, setcategoryComparisonData] = useState<any>()


    const generateMonths = (newStart: Dayjs | null, newEnd: Dayjs | null) => {
        if (!newStart || !newEnd) return [];

        const months: string[] = [];
        let current = newStart.startOf("month");

        while ((current.isBefore(newEnd) || current.isSame(newEnd, "month")) && months.length < MAX_MONTHS_DISPLAYED) {
            months.push(current.format("MMM-YY"));
            current = current.add(1, "month");
        }

        return months.reverse();
    };

    useEffect(() => {
        if (startMonth && endMonth) {
            const months = generateMonths(startMonth, endMonth);
            setFilteredMonths(months);
        }
    }, [startMonth, endMonth]);

    useEffect(() => {
        if (Clientlist.length > 2) {
            // setSelectedClient(Clientlist[2]);
            setSelectedGroupDbName(Clientlist[2]);
        }
    }, [Clientlist]);

    useEffect(() => {
        setSelectedGroupDbName(selectedClientName)
    }, [selectedClientName])
    useEffect(() => {
        handleGetClientList();
    }, [selectedGroupDbName])

    const handleGetClientList = async () => {
        const data = `?ClientGroupName=${selectedGroupDbName?.clientGroupName}`
        if (!selectedGroupDbName) return
        try {
            const res: any = await ApiGetClientEntityByClientGroupId(data)
            setClientEntities(res.data)
        } catch (error) {
            console.error("Error during API call:", error)
        }
    }
    const transformDataForCategoryComparison = () => {
        const dataToUse = reportData;

        if (!dataToUse.length || !filteredMonths.length) return [];

        const uniqueCategory = Array.from(new Set(dataToUse.map(item => item.categoryName)));

        const formatMonthKey = (month: number, year: number) => {
            const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            return `${monthNames[month - 1]}-${year.toString().slice(-2)}`;
        };

        const categoryComparisonData = uniqueCategory.map(category => {
            const categoryRating: Record<string, string> = {};
            filteredMonths.forEach(month => {
                categoryRating[month] = "N/A";
            });

            dataToUse
                .filter(item => item.categoryName === category)
                .forEach(item => {
                    const monthKey = formatMonthKey(item.reportMonth, item.reportYear);
                    if (filteredMonths.includes(monthKey)) {
                        if (categoryRating[monthKey] === "N/A") {
                            categoryRating[monthKey] = item.score;
                        } else {
                            const current = parseFloat(categoryRating[monthKey]);
                            const newScore = parseFloat(item.score);
                            if (!isNaN(current) && !isNaN(newScore)) {
                                categoryRating[monthKey] = ((current + newScore) / 2).toFixed(2);
                            }
                        }
                    }
                });

            return {
                category,
                ratings: categoryRating
            };
        });

        return categoryComparisonData.sort((a:any,b:any)=> a.category.localeCompare(b.category));
    };

    const getcategoryreport = async () => {
       if(endMonth && startMonth && selectedEntityId){
        try {
            const data = `?clientEntityId=${selectedEntityId}&startMonth=${startMonth?.month()+1}&startYear=${startMonth.year()}&endMonth=${endMonth?.month()+1}&endYear=${endMonth.year()}`
            const res = await ApigetCategoryCmparisionReport(data, selectedClient?.clientName)
            if(res){
                setReportData(res.data)
            }
        } catch (error) {
            console.log("Error", error)
        }
    }
    }
    useEffect(() => {
           getcategoryreport()
       
    }, [endMonth,startMonth,selectedEntityId])


    useEffect(() => {

        setcategoryComparisonData(transformDataForCategoryComparison())

    }, [reportData])

   const getcategoryExcel = async () => {
       if(endMonth && startMonth && selectedEntityId){
        try {
            const data = `?clientEntityId=${selectedEntityId}&startMonth=${startMonth?.month()+1}&startYear=${startMonth.year()}&endMonth=${endMonth?.month()+1}&endYear=${endMonth.year()}`
            const res = await ApigetCategoryCmparisionExcel(data, selectedClient?.clientName)

            const blob = new Blob([res], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Category_Report.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        } catch (error) {
            console.log("Error", error)
        }
    }
    }

    return (
        <Box sx={{ p: 4 }} style={{ background: "white" }}>
            <Box>
                <Box sx={{ width: "100%" }}>
                    <Typography variant="h3" textAlign="center">
                        Category Report-YTD
                    </Typography>
                </Box>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "-70px",
                        marginTop: "23px",
                    }}
                >
                    <Stack direction="row" spacing={2}>
                        <FormControl size="small" sx={{ width: 180, mb: 0 }}>
                            <Autocomplete
                                disablePortal
                                id="group-autocomplete"
                                options={Clientlist}
                                value={selectedGroupDbName}
                                getOptionLabel={(option: any) => option.clientGroupName || ""}
                                isOptionEqualToValue={(option: any, value: any) => option.clientGroupDBName === value.clientGroupDBName}
                                onChange={(event, value) => {
                                    dispatch(setSelectedClientGroup(value))
                                    setClients([]);
                                    setSelectedClient(null);
                                    setClientEntities([]);
                                    setSelectedEntityId(null);
                                    setReportData([]);
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} label="Select Client" />
                                )}
                                size="small"
                            />
                        </FormControl>
                        <FormControl size="small" sx={{ width: 185 }}>
                            <Autocomplete
                                disablePortal
                                id="mm-autocomplete"
                                options={clientEntities}

                                getOptionLabel={(option: any) => option.entityName}
                                value={clientEntities.find((entity) => entity.clientEntityId === selectedEntityId) || null}
                                onChange={(event: any, value: ClientEntity | null) => {
                                    setSelectedEntityId(value?.clientEntityId || null);
                                    setReportData([]);
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} label="Select Business" />
                                )}
                                size="small"
                            />
                        </FormControl>
                    </Stack>
                    <Stack direction="row" spacing={2}>
                        <Button variant="contained" onClick={()=>{getcategoryExcel()}} sx={{ backgroundColor: "#6b5e34", borderRadius: "8px", px: 3, "&:hover": { backgroundColor: "#5a522c" } }}>
                            DOWNLOAD AS XLSX
                        </Button>
                        {/* <Button variant="contained" sx={{ backgroundColor: "#6b5e34", borderRadius: "8px", px: 3, "&:hover": { backgroundColor: "#5a522c" } }}
                            onClick={() => handleDownloadPdf()}>
                            DOWNLOAD AS PDF
                        </Button> */}
                    </Stack>
                </Box>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "20px",
                        gap: "20px",
                        flexWrap: "wrap",
                    }}
                >
                    <Box display="flex" justifyContent="center" mt={1}>
                        <Box>
                            <Stack direction="row" spacing={2}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        views={['year', 'month']}
                                        label="Start Month"
                                        openTo="month"
                                        value={startMonth}
                                        onChange={(newValue) => {
                                            setStartMonth(newValue);
                                            if (!newValue) {
                                                setEndMonth(null);
                                            }
                                        }}
                                        slotProps={{
                                            textField: {
                                                size: 'small',
                                                sx: {
                                                    width: 180,
                                                    '& .MuiInputBase-root': { height: 40 }
                                                }
                                            }
                                        }}
                                    />
                                </LocalizationProvider>

                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        views={['year', 'month']}
                                        label="End Month"
                                        openTo="month"
                                        value={endMonth}
                                        onChange={(newValue) => setEndMonth(newValue)}
                                        minDate={startMonth || undefined}
                                        disabled={!startMonth}
                                        slotProps={{
                                            textField: {
                                                size: 'small',
                                                sx: {
                                                    width: 180,
                                                    '& .MuiInputBase-root': { height: 40 }
                                                }
                                            }
                                        }}
                                    />
                                </LocalizationProvider>
                            </Stack>
                        </Box>
                    </Box>
                </Box>
            </Box>
            <Box ref={pdfRef} sx={{ padding: '10px' }}>
                <Box sx={{ border: "2px solid #6b773c", borderRadius: "8px", overflow: "hidden", marginTop: "20px" }}>
                    <Typography variant="h4" sx={{ textAlign: "center", backgroundColor: "#d9e4c3", py: 2 }}>
                        Category Comparison Report
                    </Typography>
                    {filteredMonths.length > 0 && (
                        <Box sx={{ backgroundColor: "#eaf4d3", borderRadius: "8px" }}>
                            <Table sx={{ tableLayout: "fixed", minWidth: "100%" }}>
                                <TableHead>
                                    <TableRow className="table-row-background" sx={{ color: "white" }}>
                                        <TableCell sx={{ width: '10%', fontWeight: "bold", color: "white", position: "sticky", left: 0, zIndex: 2 }}>
                                            Category Name
                                        </TableCell>
                                        {filteredMonths.map((month) => (
                                            <TableCell key={month} sx={{ fontWeight: "bold", color: "white", textAlign: "center" }}>
                                                {month}
                                            </TableCell>
                                        ))}
                                        <TableCell sx={{ fontWeight: "bold", color: "white", textAlign: "center", position: "sticky", right: 0, zIndex: 2 }}>
                                            Avg
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {categoryComparisonData.map((row: any) => {
                                        const filteredRatings = filteredMonths?.map((month) => row?.ratings[month] ?? "N/A");
                                        const numericValues = filteredRatings
                                            .filter((val) => val !== "N/A")
                                            .map(val => parseFloat(val))
                                            .filter(num => !isNaN(num));
                                        const average = numericValues.length > 0
                                            ? (numericValues?.reduce((a, b) => a + b, 0) / numericValues?.length).toFixed(2)
                                            : "N/A";
                                        return (
                                            <TableRow key={row.category}>
                                                <TableCell sx={{ fontWeight: "bold", position: "sticky", left: 0, backgroundColor: "#ffffff", zIndex: 1 }}>
                                                    {row?.category}
                                                </TableCell>
                                                {filteredRatings?.map((rating, index) => (
                                                    <TableCell key={index} sx={{ textAlign: "center", backgroundColor: "#ffffff" }}>
                                                        {rating}
                                                    </TableCell>
                                                ))}
                                                <TableCell sx={{ fontWeight: "bold", textAlign: "center", position: "sticky", right: 0, backgroundColor: "#ffffff", zIndex: 1, borderLeft: "3px solid gray" }}>
                                                    {average}
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </Box>
                    )}
                </Box>
            </Box>
        </Box>
    );
};

export default CategoryReport;